<div fxLayout="column" fxLayoutAlign="center center">
  <div mat-dialog-content>
    {{ 'CONFIRM.MESSAGE' | translate}}
  </div>
  <div mat-dialog-actions>
    <div fxLayout="row">
      <button fxFlex="50" mat-flat-button type="button" (click)="dialogRef.close()">{{ 'CONFIRM.CANCEL' | translate}}</button>
      <button fxFlex="50" mat-flat-button  type="button" (click)="dialogRef.close(true)" color="warn">{{ 'CONFIRM.CONFIRM' | translate}}</button>
    </div>
  </div>
</div>
